/**
 * offer.js — JS for single-offer.php
 *
 * • Gallery lightbox  (data-lightbox-trigger / data-lightbox / data-lightbox-*)
 * • CF7 hidden-field injection handled inline in single-offer.php
 */

// ─── Lightbox ────────────────────────────────────────────────────────────────
function initOfferLightbox() {
    const lightbox  = document.getElementById('offer-lightbox');
    if (!lightbox) return;

    const imgEl     = document.getElementById('lightbox-img');
    const triggers  = document.querySelectorAll('[data-lightbox-trigger]');
    const btnClose  = lightbox.querySelector('[data-lightbox-close]');
    const btnPrev   = lightbox.querySelector('[data-lightbox-prev]');
    const btnNext   = lightbox.querySelector('[data-lightbox-next]');

    const images = Array.from(triggers).map(t => ({
        src: t.dataset.src,
        alt: t.dataset.alt || '',
    }));

    let current = 0;

    function open(index) {
        current = index;
        show();
    }

    function show() {
        imgEl.src = images[current].src;
        imgEl.alt = images[current].alt;
        lightbox.classList.remove('hidden');
        lightbox.classList.add('flex');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        lightbox.classList.add('hidden');
        lightbox.classList.remove('flex');
        document.body.style.overflow = '';
        imgEl.src = '';
    }

    function prev() {
        current = (current - 1 + images.length) % images.length;
        show();
    }

    function next() {
        current = (current + 1) % images.length;
        show();
    }

    triggers.forEach((t, i) => t.addEventListener('click', () => open(i)));

    if (btnClose) btnClose.addEventListener('click', close);
    if (btnPrev)  btnPrev.addEventListener('click',  (e) => { e.stopPropagation(); prev(); });
    if (btnNext)  btnNext.addEventListener('click',  (e) => { e.stopPropagation(); next(); });

    // Close on backdrop click
    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) close();
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (lightbox.classList.contains('hidden')) return;
        if (e.key === 'Escape')     close();
        if (e.key === 'ArrowLeft')  prev();
        if (e.key === 'ArrowRight') next();
    });
}

// ─── Public API ──────────────────────────────────────────────────────────────
function init() {
    initOfferLightbox();
}

export default { init };



